import { render, staticRenderFns } from "./ArrowButton.vue?vue&type=template&id=55dfab1b&scoped=true"
import script from "./ArrowButton.vue?vue&type=script&lang=js"
export * from "./ArrowButton.vue?vue&type=script&lang=js"
import style0 from "./ArrowButton.vue?vue&type=style&index=0&id=55dfab1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dfab1b",
  null
  
)

export default component.exports